import { render, staticRenderFns } from "./TaxRateDialog.vue?vue&type=template&id=381dfa5c&scoped=true&"
import script from "./TaxRateDialog.vue?vue&type=script&lang=js&"
export * from "./TaxRateDialog.vue?vue&type=script&lang=js&"
import style0 from "./TaxRateDialog.vue?vue&type=style&index=0&id=381dfa5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381dfa5c",
  null
  
)

export default component.exports